import React, { useEffect } from 'react';
import { Form } from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'align': [] }],
        ['link', 'image'], // Добавьте ссылку и изображение, если необходимо
    ],
    clipboard: {
        matchVisual: false, // Это позволяет вставлять HTML-код без лишнего форматирования
    },
};

const formats = [
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet', 'align',
    'link', 'image', // Добавьте форматы для ссылки и изображения, если необходимо
];

const TextEditor = ({ value, onChange, placeholder, defaultValue }) => {

    useEffect(() => {
        if (defaultValue && !value) {
            onChange(defaultValue);
        }
    }, [defaultValue, onChange, value]);

    return (
        <ReactQuill
            placeholder={placeholder}
            style={{ height: '300px' }}
            value={value}
            onChange={onChange}
            modules={modules}
            formats={formats}
            theme="snow"
        />
    );
};

export default TextEditor;
